import Service from "../Service";

const resource = "TicEquipmentModel/";

export default {
    list(search, requestID) {
        return Service.post(resource + "list", { search: search || "" }, {
            params: { requestID: requestID },
        });
    },

    save(model, requestID) {
        return Service.post(resource + "save", model, {
            params: { requestID: requestID },
        });
    },
};
